//@flow
import type { AddressType } from 'digicel-kaizen-library';
import type { errorMapForOrderStateType } from '../PollingOrder/lib';
import I18n from '../../lib/i18n';

export type BillingAddressActionType =
  | {|
      type: 'UPDATE_BILLING_ADDRESS',
      payload: {|
        billingAddress: AddressType,
        errorMapForOrderState: errorMapForOrderStateType,
      |},
    |}
  | {|
      type: 'UPDATE_BILLING_ADDRESS_FAILURE',
      payload: {|
        error: any,
      |},
    |}
  | {|
      type: 'UPDATE_BILLING_ADDRESS_DURING_PROCESS',
      payload: {|
        billingAddress: AddressType,
      |},
    |};

export const updateBillingAddress = (billingAddress: AddressType): BillingAddressActionType => ({
  type: 'UPDATE_BILLING_ADDRESS',
  payload: {
    billingAddress,
    errorMapForOrderState: {
      key: 'updateBillingAddress',
      type: {
        FAILED: {
          title: I18n.t('Dashboard.UpdateBillingAddress.failureTitle'),
        },
        IN_PROGRESS: {
          title: I18n.t('Dashboard.UpdateBillingAddress.inProgressTitle'),
        },
      },
    },
  },
});

export const updateBillingAddressFailure = (error: any): BillingAddressActionType => ({
  type: 'UPDATE_BILLING_ADDRESS_FAILURE',
  payload: {
    error,
  },
});

export const updateBillingAddressDuringProcess = (billingAddress: AddressType): BillingAddressActionType => ({
  type: 'UPDATE_BILLING_ADDRESS_DURING_PROCESS',
  payload: {
    billingAddress,
  },
});
